import { FormRegister } from '@/types'
import { NewCandidate } from '@/proxy/Prequalification.CandidateMgt.FacadeClient';

export const registerForm: FormRegister = {
  candidate: {} as NewCandidate,
  showError: false,
  error: 'general.error',
  recaptchaToken: '',
  values: {
    conditionsGDPR: false
  },

  errors: {
    // STEP 2 - contact detail
    contactFor: { checkAtLeastOneOption: 'register.contacts.errors.required.contactFor', errors: [true] },
    allCompetences: { allRequired: 'register.contacts.errors.required.allcompetences', error: true },
    singleinvestment: { singleinvestment: 'register.contacts.errors.required.singleinvestment', error: false },
  },

  userLanguages: [
    { value: 'en', label: 'en' },
    { value: 'fr', label: 'fr' },
    { value: 'nl', label: 'nl' }
  ],
}
